export default "__VITE_ASSET__36350f6e__"